import type { Router } from 'vue-router';
import type { PendingAiProjectCreateHydration } from '@/stores/useAppShellStore';
import { useProjectCreateDraftStore } from '@/stores/useProjectCreateDraftStore';

type ShellAutofill = {
  setDashboardExpandedAiComposer: (on: boolean) => void;
  startProjectAutofillIntro: () => void;
  endProjectAutofillIntro: () => void;
  setPendingAiProjectCreateHydration: (payload: PendingAiProjectCreateHydration | null) => void;
};

/** 全屏「开始自动填充项目信息」展示时长（毫秒） */
export const PROJECT_AUTOFILL_INTRO_MS = 2100;

/**
 * 先展示全局过渡文案，再写入 hydration 并进入创建项目页。
 * 进入 ProjectCreate 后由 Layout 根据路由收起遮罩。
 * @returns 是否已成功进入 ProjectCreate（被路由守卫重定向时为 false）
 */
export async function runProjectAutofillIntroSequence(
  shellStore: ShellAutofill,
  router: Router,
  payload: PendingAiProjectCreateHydration,
  durationMs: number = PROJECT_AUTOFILL_INTRO_MS,
): Promise<boolean> {
  shellStore.setDashboardExpandedAiComposer(false);
  shellStore.startProjectAutofillIntro();
  try {
    await new Promise<void>((resolve) => setTimeout(resolve, durationMs));
    shellStore.setPendingAiProjectCreateHydration(payload);
    const draftKey = useProjectCreateDraftStore().createDraft();
    await router.push({ name: 'ProjectCreate', query: { draft: draftKey } });
    if (router.currentRoute.value.name !== 'ProjectCreate') {
      shellStore.setPendingAiProjectCreateHydration(null);
      shellStore.endProjectAutofillIntro();
      return false;
    }
    return true;
  } catch {
    shellStore.setPendingAiProjectCreateHydration(null);
    shellStore.endProjectAutofillIntro();
    return false;
  }
}
